import { getEligiblesContent } from '../../new_header/components/hot-yoter-eligibles-popup/utils/getEligiblesContent';
import { HOT_YOTER_VIEW_PURCHASED_LABEL } from '../constants';

export const getHotYoterStateText = (stateTexts, userData, fallbackStateTexts = null, translations) => {
    const content = getEligiblesContent(
        stateTexts ?? fallbackStateTexts,
        userData,
        undefined,
        translations,
    );

    return {
        state: content.state,
        badgeCount: content.badgeCount,
        title: content.title,
        subtitle: content.subtitle,
        actionLabel: content.actionLabel,
    };
};

export const parseSubtitleWithViewAction = (
    subtitle,
    actionLabel = HOT_YOTER_VIEW_PURCHASED_LABEL,
) => {
    const trimmedSubtitle = subtitle?.trim() ?? '';
    const trimmedLabel = (actionLabel ?? HOT_YOTER_VIEW_PURCHASED_LABEL).trim();

    if (!trimmedSubtitle) {
        return { textBefore: '', showComma: false };
    }

    if (trimmedLabel && trimmedSubtitle.endsWith(trimmedLabel)) {
        const before = trimmedSubtitle
            .slice(0, -trimmedLabel.length)
            .replace(/,\s*$/, '')
            .trim();

        return { textBefore: before, showComma: Boolean(before) };
    }

    const textBefore = trimmedSubtitle.replace(/,\s*$/, '').trim();

    return { textBefore, showComma: Boolean(textBefore) };
};
